import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class ConsolidationReportData extends ReportData<ConsolidationReportData> {
    @field exclusive: boolean = true;

}
